export const isEmpty = obj => obj ? Object.keys(obj).length === 0 : true;

export const isNumber = (value) => typeof value === 'number' && !isNaN(value);

export const handleDate = (date) => {
    if (!date) {
      return '-';
    }
    const newDate = new Date(date);
    return `${newDate.getMonth() + 1}/${newDate.getDate()}/${newDate.getFullYear()}`;
  };

export function getNameByLocation(benchmark, i18n) {
  return i18n.language === "en"
    ? benchmark?.eng_name || benchmark?.name
    : benchmark?.name;
}

export const renderDownloadLink = (labelKey, fileData, fileName, t,) => {
  if (!fileData) return null; // Skip if there's no file data

  return (
    <tr className="index-table-about-row">
      <th className="index-table-about-th">{t(labelKey)}</th>
      <td className="index-table-about-td">
        <button
          className="index-table-about-link"
          onClick={() => {
            const binaryString = window.atob(fileData);
            const bytes = new Uint8Array(binaryString.length);
            for (let i = 0; i < binaryString.length; i++) {
              bytes[i] = binaryString.charCodeAt(i);
            }
            const blob = new Blob([bytes], { type: "application/pdf" });
            const safeFileName = fileName?.endsWith(".pdf")
              ? fileName.replace(/ /g, "_")
              : `${fileName.replace(/ /g, "_")}.pdf`;
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = safeFileName;
            link.click();
          }}
        >
          {t(labelKey)}
        </button>
      </td>
    </tr>
  );
};
